import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.find.js";
import dayjs from 'dayjs';
import draggable from 'vuedraggable';
var ModalNew = function ModalNew() {
  return import('@/components/organisms/ModalNew');
};
var ArenaGameBattleList = function ArenaGameBattleList() {
  return import('@/components/organisms/ArenaGameBattleList');
};
var ArenaGameTeamBattleList = function ArenaGameTeamBattleList() {
  return import('@/components/organisms/ArenaGameTeamBattleList');
};
var AssetImage = function AssetImage() {
  return import('@/components/atoms/AssetImage');
};
var PageHeader = function PageHeader() {
  return import('@/components/molecules/PageHeader');
};
var CountDown = function CountDown() {
  return import('@/components/molecules/CountDown');
};
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
import Nl2br from 'vue-nl2br';
var MultiPageModal = function MultiPageModal() {
  return import('@/components/organisms/MultiPageModal');
};
var PartySlider = function PartySlider() {
  return import('@/components/molecules/PartySlider');
};
var UnitImage = function UnitImage() {
  return import('@/components/atoms/UnitImage');
};
var JoinArenaModal = function JoinArenaModal() {
  return import('@/components/organisms/JoinArenaModal');
};
var PageTitle = function PageTitle() {
  return import('@/components/molecules/PageTitle');
};
var Tournament = function Tournament() {
  return import('@/components/molecules/Tournament');
};
var RarityIcon = function RarityIcon() {
  return import('@/components/atoms/RarityIcon');
};
var LoadingSpinner = function LoadingSpinner() {
  return import('@/components/atoms/LoadingSpinner');
};
var AccessoryImage = function AccessoryImage() {
  return import('@/components/atoms/AccessoryImage');
};
export default {
  components: {
    AssetImage: AssetImage,
    PageHeader: PageHeader,
    ArenaGameBattleList: ArenaGameBattleList,
    ArenaGameTeamBattleList: ArenaGameTeamBattleList,
    ModalNew: ModalNew,
    CountDown: CountDown,
    Modal: Modal,
    draggable: draggable,
    Nl2br: Nl2br,
    MultiPageModal: MultiPageModal,
    PartySlider: PartySlider,
    UnitImage: UnitImage,
    JoinArenaModal: JoinArenaModal,
    PageTitle: PageTitle,
    Tournament: Tournament,
    RarityIcon: RarityIcon,
    LoadingSpinner: LoadingSpinner,
    AccessoryImage: AccessoryImage
  },
  // middleware: 'walletCheck',
  data: function data() {
    return {
      arenaGame: {},
      isResultVisibilityModalShown: false,
      confirmJoinModalShown: false,
      isShareModalShown: false,
      confirmCancelModalShown: false,
      confirmLeaveModalShown: false,
      isEntryModalShown: false,
      finishedLoading: false,
      teamOne: [],
      teamTwo: [],
      ownTeam: [],
      selectedTemplate: null,
      updatePlayersIntervalId: 0,
      starterUnits: [],
      isLoading: false,
      guildInfos: [],
      limitData: [],
      accessories: [],
      resultVisibility: 0
    };
  },
  computed: {
    me: function me() {
      return useUserStore().me;
    },
    getUser: function getUser() {
      return useUserStore().getUser;
    },
    getHero: function getHero() {
      return useHeroStore().getHero;
    },
    getExtension: function getExtension() {
      return useExtensionStore().getExtension;
    },
    user: function user() {
      return this.me || {};
    },
    ownTeamId: function ownTeamId() {
      return this.teamGame.attackerUidsList.includes(this.user.uid) ? 1 : 2;
    },
    teamGame: function teamGame() {
      return this.arenaGame.teamGame || {};
    },
    leagueGame: function leagueGame() {
      return this.arenaGame.league || {};
    },
    isLeagueGame: function isLeagueGame() {
      return this.arenaGame.arenaType === 1;
    },
    tournamentGame: function tournamentGame() {
      return this.arenaGame.tournament || {};
    },
    isTournament: function isTournament() {
      return this.arenaGame.arenaType === 3;
    },
    isNineBattle: function isNineBattle() {
      return this.arenaGame.battleType === 1;
    },
    isTeamGame: function isTeamGame() {
      return this.arenaGame.arenaType === 2;
    },
    arenaId: function arenaId() {
      return Number(this.$route.params.arenaId);
    },
    isInPreperation: function isInPreperation() {
      return this.arenaGame.status < 3;
    },
    isPublic: function isPublic() {
      return this.arenaGame.isPublic ? 'Public' : 'Private';
    },
    isCryptidBuffOn: function isCryptidBuffOn() {
      return this.arenaGame.isCryptidEffected ? 'Active' : 'Off';
    },
    isBattleRules: function isBattleRules() {
      return this.getArenaBattleTypeStr(this.arenaGame.arenaType);
    },
    isMaxParticipant: function isMaxParticipant() {
      return this.getMaxParticipant(this.arenaGame.arenaType);
    },
    participantCount: function participantCount() {
      if (this.arenaGame.arenaType === 1) return (this.arenaGame.league.uidsList || []).length;
      if (this.arenaGame.arenaType === 2) {
        return (this.arenaGame.teamGame.attackerUidsList || []).length + (this.arenaGame.teamGame.defenderUidsList || []).length;
      }
      if (this.arenaGame.arenaType === 3) return (this.arenaGame.tournament.uidsList || []).length;
    },
    allUsers: function allUsers() {
      if (this.isLeagueGame) {
        return this.leagueGame.uidsList;
      } else if (this.isTeamGame) {
        return this.teamGame.attackerUidsList.concat(this.teamGame.defenderUidsList);
      } else if (this.isTournament) {
        return this.tournamentGame.uidsList;
      }
      return [];
    },
    usersLeague: function usersLeague() {
      var _this = this;
      return (this.leagueGame.uidsList || []).map(function (u) {
        return _this.getUser(u) || {};
      });
    },
    usersTeamOne: function usersTeamOne() {
      var _this2 = this;
      return (this.teamGame.attackerUidsList || []).map(function (u) {
        return _this2.getUser(u) || {};
      });
    },
    usersTeamTwo: function usersTeamTwo() {
      var _this3 = this;
      return (this.teamGame.defenderUidsList || []).map(function (u) {
        return _this3.getUser(u) || {};
      });
    },
    usersTournament: function usersTournament() {
      var _this4 = this;
      return (this.tournamentGame.uidsList || []).map(function (u) {
        return _this4.getUser(u) || {};
      });
    },
    battleStart: function battleStart() {
      return dayjs(this.arenaGame.battledAt, 'X');
    },
    didJoin: function didJoin() {
      return (this.allUsers || []).includes(this.user.uid);
    },
    canShare: function canShare() {
      return this.user.uid === this.arenaGame.ownerId && this.arenaGame.status == 1;
    },
    urlForTwitter: function urlForTwitter() {
      var baseUrl = 'https://twitter.com/intent/tweet';
      var text = "".concat(this.arenaGame.title, " ").concat(this.$t('playerMatch.tweet.twitterText1'), " ").concat(this.timeString, "! ").concat(this.$t('playerMatch.tweet.twitterText2'));
      var params = Object.entries({
        text: encodeURIComponent(text),
        url: this.currentUrl,
        hashtags: ['BFHeroes', 'ブレヒロ'].join(',')
      }).map(function (param) {
        return param.join('=');
      }).join('&');
      return "".concat(baseUrl, "?").concat(params);
    },
    currentUrl: function currentUrl() {
      if (process.server) return;
      var path = this.localePath({
        path: "/duel/arena",
        query: {
          pw: this.arenaGame.password
        }
      }, 'en');
      return "".concat(this.$env.siteUrl.slice(0, -1)).concat(path);
    },
    timeString: function timeString() {
      var now = dayjs();
      var diff = this.battleStart.diff(now) * 0.001; // convert to seconds
      var hours = Math.floor(diff / 3600);
      var hoursString = hours ? hours + ' ' + this.$t('playerMatch.tweet.hour') + this.pluralize(hours) : '';
      var mins = Math.floor(diff % 3600 / 60);
      var minsString = mins ? mins + ' ' + this.$t('playerMatch.tweet.minute') + this.pluralize(mins) : '';
      var renderAnd = hours && mins ? ' ' + this.$t('playerMatch.tweet.and') + ' ' : '';
      return hoursString + renderAnd + minsString;
    },
    getStarterUnits: function getStarterUnits() {
      var starter = this.$util.clone(this.starterUnits);
      starter.sort(function (p, c) {
        if (p.position < c.position) return -1;
        if (p.position > c.position) return 1;
        return 0;
      });
      return starter;
    },
    isLimitedLegendaryAllow: function isLimitedLegendaryAllow() {
      return this.arenaGame.isLimitedLegendaryAllow;
    },
    availableOriginalHeroRarities: function availableOriginalHeroRarities() {
      var _this5 = this;
      if (!this.arenaGame.bannedRarity) return [];
      return [5, 4, 3, 2, 1, 0].filter(function (num) {
        return !_this5.arenaGame.bannedRarity.heroRaritiesList.includes(num);
      });
    },
    availableReplicaHeroRarities: function availableReplicaHeroRarities() {
      var _this6 = this;
      if (!this.arenaGame.bannedRarity) return [];
      return [5, 4, 3, 2].filter(function (num) {
        return !_this6.arenaGame.bannedRarity.replicaHeroRaritiesList.includes(num);
      });
    },
    availableOriginalExtensionRarities: function availableOriginalExtensionRarities() {
      var _this7 = this;
      if (!this.arenaGame.bannedRarity) return [];
      return [5, 4, 3, 2, 1, 0].filter(function (num) {
        return !_this7.arenaGame.bannedRarity.originalExtensionRaritiesList.includes(num);
      });
    },
    availableReplicaExtensionRarities: function availableReplicaExtensionRarities() {
      var _this8 = this;
      if (!this.arenaGame.bannedRarity) return [];
      return [7, 6, 5, 4, 3, 2, 1].filter(function (num) {
        return !_this8.arenaGame.bannedRarity.replicaExtensionRaritiesList.includes(num);
      });
    },
    availableAccessoryRarities: function availableAccessoryRarities() {
      var _this9 = this;
      if (!this.arenaGame.bannedRarity) return [];
      return [5, 4, 3, 2, 1].filter(function (num) {
        return !_this9.arenaGame.bannedRarity.accessoryRaritiesList.includes(num);
      });
    },
    isNoSameHero: function isNoSameHero() {
      var rules = this.$util.clone(this.arenaGame.rulesMap);
      var map = new Map(rules);
      return map.get(1);
    },
    isAttributeNumberLimit: function isAttributeNumberLimit() {
      var check = false;
      this.attributeLimitData.forEach(function (x) {
        if (x.limit < 5 && x.limit > 0) check = true;
      });
      return check;
    },
    attributeLimitData: function attributeLimitData() {
      if (!Object.keys(this.arenaGame).length) return [];
      var attributeLimit = this.$util.clone(this.arenaGame.heroAttributeLimitMap);
      var isLimit = false;
      var attributeLimitData = [];
      attributeLimit.forEach(function (x) {
        if (x[1] != 0) {
          var pushData = {
            attr: x[0],
            limit: x[1]
          };
          if (x[1] != 5) isLimit = true;
          attributeLimitData.push(pushData);
        } else {
          isLimit = true;
        }
      });
      return !isLimit ? [] : attributeLimitData;
    },
    resultVisibilityStr: function resultVisibilityStr() {
      switch (this.arenaGame.resultVisibility) {
        case 0:
          {
            return this.$t('playerMatch.createLobby.options.allUsers');
          }
        case 1:
          {
            return this.$t('playerMatch.createLobby.options.participantsOnly');
          }
        case 2:
          {
            return this.$t('playerMatch.createLobby.options.hostOnly');
          }
      }
    },
    canViewResult: function canViewResult() {
      if (this.arenaGame.resultVisibility == 0) {
        return true;
      }
      if (this.arenaGame.resultVisibility == 1) {
        return this.allUsers.includes(this.user.uid) || this.arenaGame.ownerId == this.user.uid;
      }
      return this.arenaGame.ownerId == this.user.uid;
    },
    isArenaEnd: function isArenaEnd() {
      if (this.isTournament) {
        return this.arenaGame.status == 6 || this.arenaGame.status == 3;
      }
      return this.arenaGame.status == 3 && !!this.arenaGame.battlesList.length;
    }
  },
  beforeMount: function beforeMount() {
    var _this10 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var decksMap, heros, extensions, i, accessoryIds, guildIds, upperLimit, lowerLimit;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this10.isLoading = true;
            _context2.next = 3;
            return _this10.fetchArenaInfo();
          case 3:
            _context2.next = 5;
            return useUserStore().fetchUsers(_this10.allUsers);
          case 5:
            if (_this10.didJoin) {
              _context2.next = 8;
              break;
            }
            _context2.next = 8;
            return _this10.fetchMyOwnHeroes();
          case 8:
            _this10.teamOne = _this10.usersTeamOne;
            _this10.teamTwo = _this10.usersTeamTwo;
            _this10.finishedLoading = true;
            if (_this10.arenaGame.status != 3) {
              _this10.updatePlayersIntervalId = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return _this10.updatePlayers();
                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              })), 2000);
            }
            _context2.next = 14;
            return useDeckTemplateStore().fetchDeckTemplates();
          case 14:
            if (!(_this10.didJoin && _this10.arenaGame.status != 3)) {
              _context2.next = 30;
              break;
            }
            _context2.next = 17;
            return _this10.$teamsService.getMyOwnArenaTeam();
          case 17:
            decksMap = _context2.sent;
            _this10.starterUnits = decksMap.get(_this10.arenaId).unitsList;
            heros = [];
            extensions = [];
            for (i = 0; i < _this10.starterUnits.length; i++) {
              heros.push(_this10.starterUnits[i].heroId);
              extensions.push(_this10.starterUnits[i].extensionIdsList[0]);
              extensions.push(_this10.starterUnits[i].extensionIdsList[1]);
            }
            accessoryIds = _this10.$util.flat(_this10.starterUnits.map(function (unit) {
              return unit.accessoryId;
            })).filter(function (a) {
              return a != 0;
            });
            _context2.next = 25;
            return _this10.$accessoryService.getAccessories(accessoryIds);
          case 25:
            _this10.accessories = _context2.sent;
            _context2.next = 28;
            return _this10.fetchHeroes(_this10.$util.uniq(heros));
          case 28:
            _context2.next = 30;
            return _this10.fetchExtensions(_this10.$util.uniq(extensions));
          case 30:
            if (!_this10.allUsers.length) {
              _context2.next = 37;
              break;
            }
            guildIds = [];
            _this10.allUsers.forEach(function (u) {
              if (_this10.getUser(u).guildId > 0) {
                guildIds.push(_this10.getUser(u).guildId);
              }
            });
            if (!guildIds.length) {
              _context2.next = 37;
              break;
            }
            _context2.next = 36;
            return _this10.$landGuildService.GetGuildInfos(guildIds);
          case 36:
            _this10.guildInfos = _context2.sent;
          case 37:
            upperLimit = _this10.$util.clone(_this10.arenaGame.heroRarityUpperLimitMap);
            upperLimit.sort(function (p, c) {
              if (p[0] < c[0]) return -1;
              if (p[0] > c[0]) return 1;
              return 0;
            });
            upperLimit.forEach(function (x) {
              if (x[1] != 0 && x[1] != 5) {
                var pushData = {
                  rarity: x[0],
                  limit: x[1],
                  upper: true
                };
                _this10.limitData.push(pushData);
              }
            });
            lowerLimit = _this10.$util.clone(_this10.arenaGame.heroRarityLowerLimitMap);
            lowerLimit.forEach(function (x) {
              if (x[1] != 0 && x[1] != 5) {
                var pushData = {
                  rarity: x[0],
                  limit: x[1]
                };
                _this10.limitData.push(pushData);
              }
            });
            _this10.isLoading = false;
          case 43:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.updatePlayersIntervalId);
  },
  methods: {
    fetchMyOwnHeroes: function fetchMyOwnHeroes() {
      return useHeroStore().fetchMyOwnHeroes();
    },
    fetchHeroes: function fetchHeroes(ids) {
      return useHeroStore().fetchHeroes(ids);
    },
    fetchExtensions: function fetchExtensions(arg) {
      return useExtensionStore().fetchExtensions(arg);
    },
    fetchArenaInfo: function fetchArenaInfo() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var arenaFound;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this11.$arenaService.getArenaInfo(_this11.arenaId).catch(function (e) {
                return _this11.$toast.error(_this11.$t('arena.nothingToSee'));
              });
            case 2:
              arenaFound = _context3.sent;
              if (arenaFound) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return", _this11.gentleKick());
            case 5:
              if (!(arenaFound.status === 4 || arenaFound.status === 2)) {
                _context3.next = 8;
                break;
              }
              _this11.$toast.error(_this11.$t('arena.nothingToSee'));
              return _context3.abrupt("return", _this11.gentleKick());
            case 8:
              return _context3.abrupt("return", _this11.arenaGame = arenaFound);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    updatePlayers: function updatePlayers() {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this12.fetchArenaInfo();
            case 2:
              _context4.next = 4;
              return useUserStore().fetchUsers(_this12.allUsers);
            case 4:
              _this12.teamOne = _this12.usersTeamOne;
              _this12.teamTwo = _this12.usersTeamTwo;
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    leaveArena: function leaveArena() {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return _this13.$arenaService.leaveArena(_this13.arenaGame.arenaId);
            case 3:
              _this13.$toast.success(_this13.$t('playerMatch.successfullyLeft'));
              return _context5.abrupt("return", _this13.$router.push(_this13.localePath('duel-arena')));
            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](0);
              _this13.$toast.error(_context5.t0.message || 'Could not leave Arena.');
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 7]]);
      }))();
    },
    joinArena: function joinArena(password) {
      var _arguments = arguments,
        _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var allowForward, options, teamToJoin, selectedHeroIds, selectedTemplate, decksMap;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              allowForward = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
              options = _arguments.length > 2 ? _arguments[2] : undefined;
              teamToJoin = options.teamToJoin, selectedHeroIds = options.selectedHeroIds, selectedTemplate = options.selectedTemplate;
              _context6.prev = 3;
              _context6.next = 6;
              return _this14.$arenaService.joinArenaV2(password, teamToJoin, selectedHeroIds, selectedTemplate);
            case 6:
              _this14.$toast.success(_this14.$t('playerMatch.successfullyJoined'));
              _this14.isEntryModalShown = false;
              _context6.next = 10;
              return _this14.fetchArenaInfo();
            case 10:
              _context6.next = 12;
              return _this14.$teamsService.getMyOwnArenaTeam();
            case 12:
              decksMap = _context6.sent;
              _this14.starterUnits = decksMap.get(_this14.arenaId).unitsList;
              _context6.next = 19;
              break;
            case 16:
              _context6.prev = 16;
              _context6.t0 = _context6["catch"](3);
              _this14.$toast.error(_context6.t0.message || 'Could not join Arena.');
            case 19:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[3, 16]]);
      }))();
    },
    canJoin: function canJoin(status) {
      return status === 1 || status === 3;
    },
    gentleKick: function gentleKick() {
      return setTimeout(this.$router.push(this.localePath('duel-arena')), 2000);
    },
    copyToClipboard: function copyToClipboard(value) {
      var _this15 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var valueShownAtCopy, dummy;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              valueShownAtCopy = value.length < 8 ? value : 'Link';
              try {
                dummy = document.createElement('input');
                document.body.appendChild(dummy);
                dummy.setAttribute('value', value);
                dummy.contentEditable = true;
                dummy.readOnly = false;
                dummy.select();
                document.execCommand('copy');
                document.body.removeChild(dummy);
                _this15.$toast.success("".concat(valueShownAtCopy, " ").concat(_this15.$t('arena.copiedText')));
              } catch (_unused) {
                _this15.$toast.error(_this15.$t('arena.copiedTextFailed'));
              }
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    cancelArena: function cancelArena() {
      var _this16 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return _this16.$arenaService.cancelArena(_this16.arenaGame.arenaId);
            case 3:
              _this16.$toast.success(_this16.$t('playerMatch.successfullyCanceled'));
              _this16.confirmCancelModalShown = false;
              return _context8.abrupt("return", _this16.$router.push(_this16.localePath('duel-arena')));
            case 8:
              _context8.prev = 8;
              _context8.t0 = _context8["catch"](0);
              _this16.$toast.error(_context8.t0.message || 'Could not delete Arena.');
            case 11:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[0, 8]]);
      }))();
    },
    pluralize: function pluralize(value) {
      return this.$i18n.locale !== 'ja' && value > 1 ? 's' : '';
    },
    onDragStart: function onDragStart() {
      var playerElem = this.$el.querySelector('.groupUserList-team__item');
      playerElem.classList.add('groupUserList-team__dragging');
    },
    onDragEnd: function onDragEnd() {
      var _this17 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var playerElem;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              playerElem = _this17.$el.querySelector('.groupUserList-team__item');
              playerElem.classList.remove('groupUserList-team__dragging');
              _context9.prev = 2;
              _context9.next = 5;
              return _this17.savePlayerOrder();
            case 5:
              _context9.next = 7;
              return _this17.updatePlayers();
            case 7:
              _context9.next = 12;
              break;
            case 9:
              _context9.prev = 9;
              _context9.t0 = _context9["catch"](2);
              _this17.$toast.error(_context9.t0);
            case 12:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[2, 9]]);
      }))();
    },
    adjustTeams: function adjustTeams() {
      // moves the last player to the other team
      if (this.teamOne.length > 5) {
        var movedPlayer = this.teamOne.splice(5, 1);
        this.teamTwo.push(movedPlayer[0]);
        this.$toast.success(this.$t('arena.arenaView.movedToFire'));
      }
      if (this.teamTwo.length > 5) {
        var _movedPlayer = this.teamTwo.splice(5, 1);
        this.teamOne.push(_movedPlayer[0]);
        this.$toast.success(this.$t('arena.arenaView.movedToIce'));
      }
      if (this.teamOne.length === 0 || this.teamTwo.length === 0) {
        this.teamOne = this.usersTeamOne;
        this.teamTwo = this.usersTeamTwo;
        throw new Error('Teams cannot be empty');
      }
    },
    savePlayerOrder: function savePlayerOrder() {
      var _this18 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return _this18.$arenaService.setOwnTeamOrder(_this18.arenaGame.arenaId, _this18.ownTeamId === 1 ? _this18.teamOne.map(function (user) {
                return user.uid;
              }) : _this18.teamTwo.map(function (user) {
                return user.uid;
              }));
            case 3:
              _this18.$toast.success(_this18.$t('arena.arenaView.savedOrder'));
              _context10.next = 10;
              break;
            case 6:
              _context10.prev = 6;
              _context10.t0 = _context10["catch"](0);
              console.log(_context10.t0);
              _this18.$toast.error(_context10.t0.message || _this18.$t('arena.arenaView.errorOrder'));
            case 10:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[0, 6]]);
      }))();
    },
    getArenaBattleTypeStr: function getArenaBattleTypeStr(arenaType) {
      switch (arenaType) {
        case 1:
          return this.$t('playerMatch.createLobby.options.league');
        case 2:
          return this.$t('playerMatch.createLobby.options.team');
        case 3:
          return this.$t('playerMatch.createLobby.options.tournament');
        default:
          return this.$t('playerMatch.createLobby.options.team');
      }
    },
    getMaxParticipant: function getMaxParticipant(arenaType) {
      switch (arenaType) {
        case 1:
          return 12;
        case 2:
          return 10;
        case 3:
          return 64;
      }
    },
    getNumber: function getNumber(i) {
      if (i === 0) {
        return '1st';
      } else if (i === 1) {
        return '2nd';
      } else if (i === 2) {
        return '3rd';
      } else if (i === 3) {
        return '4th';
      } else if (i === 4) {
        return '5th';
      }
    },
    getHeroId: function getHeroId(index) {
      if (this.starterUnits[index]) return this.starterUnits[index].heroId;
      return 0;
    },
    canEntryModalFinish: function canEntryModalFinish() {
      return !!this.selectedHeroIds.length || this.selectedTemplate !== null;
    },
    isBroken: function isBroken(asset) {
      if (!this.isRep(asset) || !asset.sinceReplica || asset.sinceReplica === 0) return false;
      var msUntilBroken = this.replicaActivationEnd(asset).diff(this.$dayjs());
      return !!(msUntilBroken < 0);
    },
    daysUntilBroken: function daysUntilBroken(asset) {
      return this.replicaActivationEnd(asset).diff(this.$dayjs(), 'days');
    },
    isInUse: function isInUse(asset) {
      if (!this.isRep(asset) || !asset.sinceReplica || asset.sinceReplica === 0 || this.isBroken(asset)) return false;
      return this.daysUntilBroken(asset) >= 0;
    },
    isRep: function isRep(asset) {
      return !asset.asset && !!asset.rarity;
    },
    replicaActivationEnd: function replicaActivationEnd(asset) {
      return this.$dayjs(asset.sinceReplica || 0, 'X').add(7, 'days');
    },
    userProfilePic: function userProfilePic(user) {
      if (user.ipfs) {
        return "".concat(this.$env.cdnUrl, "/user_arts/").concat(user.ipfs);
      }
      return '';
    },
    getGuildImg: function getGuildImg(user) {
      var guildInfo = [];
      if (user.guildId > 0) {
        guildInfo = this.guildInfos.find(function (g) {
          return g.guildId == user.guildId;
        });
      }
      if (!guildInfo) return '';
      if (!Object.keys(guildInfo).length) return '';
      if (guildInfo.ipfs.includes('.png')) return "".concat(this.$env.cdnUrl, "/static/land/guildicon/").concat(guildInfo.ipfs);else return "".concat(this.$env.cdnUrl, "/user_arts/").concat(guildInfo.ipfs);
    },
    guildIcon: function guildIcon(user) {
      return this.getGuildImg(user);
    },
    getLandClass: function getLandClass(user) {
      if (user.landType == 1) {
        return 'user_landType_agni';
      } else if (user.landType == 2) {
        return 'user_landType_sama';
      } else if (user.landType == 3) {
        return 'user_landType_vriksha';
      } else if (user.landType == 4) {
        return 'user_landType_atharva';
      } else if (user.landType == 5) {
        return 'user_landType_laVeda';
      } else if (user.landType == 6) {
        return 'user_landType_bariura';
      } else {
        return 'user_landType_none';
      }
    },
    getAttrSrc: function getAttrSrc(attr) {
      return require('~/assets/images/icons/attribute_mark_' + attr + '_on.png');
    },
    getAccessory: function getAccessory(id) {
      return this.accessories.find(function (x) {
        return x.accessoryId == id;
      });
    },
    onClickResultVisibility: function onClickResultVisibility(num) {
      this.resultVisibility = num;
    },
    updateArenaResultVisbility: function updateArenaResultVisbility() {
      var _this19 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return _this19.$arenaService.updateArenaResultVisbility(_this19.arenaGame.arenaId, _this19.resultVisibility);
            case 3:
              _this19.isResultVisibilityModalShown = false;
              _this19.$toast.success('Success.');
              _context11.next = 10;
              break;
            case 7:
              _context11.prev = 7;
              _context11.t0 = _context11["catch"](0);
              _this19.$toast.error('Error.');
            case 10:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[0, 7]]);
      }))();
    }
  }
};